export const QUARTERLY = 1;
export const YEARLY = 2;
export const INDUSTRY = 'industry';

export const mapFrequency = {
  [QUARTERLY]: 'Quarterly',
  [YEARLY]: 'Yearly',
};

export const mapping = {
  organCode: 'organCode',

  valuationRatio: '',
  PE: 'ryd21',
  PB: 'ryd25',
  PS: 'ryd26',
  PCashFlow: 'ryd28',
  EPS: 'ryd14',
  BVPS: 'ryd7',
  EV: 'ryd30',

  effectiveRatio: '',
  revenue: 'rev',
  revenueGrowth: 'ryq34',
  netProfit: 'isa22',
  profitGrowth: 'ryq39',
  EBITMargin: 'ryq27',
  netProfitMargin: 'ryq29',
  grossProfitMargin: 'ryq25',
  ROE: 'ryq12',
  ROA: 'ryq14',
  ROIC: 'ryq76',

  liquidityRatio: '',
  currentRatio: 'ryq3',
  cashRatio: 'ryq1',
  quickRatio: 'ryq2',
  interestCoverage: 'ryq77',

  efficiencyRatio: '',
  assetTurnover: 'ryq31',
  fixedAssetTurnover: 'ryq91',
  daysSalesOutstanding: 'ryq16',
  daysInventoryOutstanding: 'ryq18',
  daysPayableOutstanding: 'ryq20',
  cashCycle: 'cashCycle',

  capitalStructureRatio: '',
  debt: 'ryq10',
  STAndLTBorrowing: 'ryq6',
  financialLeverage: 'ryq71',

  coporationInfomation: '',
  marketCapital: 'ryd11',
  outstandingShare: 'ryd3',
};

export const groupIndicatorsParent = [
  {
    effectiveRatio: [
      'netInterestIncome',
      'netInterestIncomeGrowth',
      'netProfit',
      'profitGrowth',
      'EBITMargin',
      'netProfitMargin',
      'grossProfitMargin',
      'ROE',
      'ROA',
      'ROIC',
    ],
  },
  {
    liquidityRatio: [
      'currentRatio',
      'cashRatio',
      'quickRatio',
      'interestCoverage',
    ],
  },
  {
    efficiencyRatio: [
      'assetTurnover',
      'fixedAssetTurnover',
      'daysSalesOutstanding',
      'daysInventoryOutstanding',
      'daysPayableOutstanding',
      'cashCycle',
    ],
  },
  {
    capitalStructureRatio: ['debt', 'STAndLTBorrowing'],
  },
  {
    valuationRatio: ['PE', 'PB', 'EPS', 'PS', 'PCashFlow', 'BVPS', 'EV'],
  },
  {
    coporationInfomation: ['marketCapital', 'outstandingShare'],
  },
];

export const defaultIndicator = [
  'revenue',
  'revenueGrowth',
  'netProfit',
  'profitGrowth',
  'EBITMargin',
  'ROE',
  'ROA',
  'ROIC',
  'debt',
  'PE',
  'PB',
  'EPS',
  'netProfitMargin',
  'grossProfitMargin',
  'currentRatio',
  'cashRatio',
  'quickRatio',
  'interestCoverage',
  'financialLeverage',
  'assetTurnover',
  'fixedAssetTurnover',
  'daysSalesOutstanding',
  'daysInventoryOutstanding',
  'daysPayableOutstanding',
  'cashCycle',
  'STAndLTBorrowing',
  'marketCapital',
  'outstandingShare',
  'PS',
  'PCashFlow',
  'BVPS',
  'EV',
  'effectiveRatio',
  'liquidityRatio',
  'efficiencyRatio',
  'capitalStructureRatio',
  'valuationRatio',
  'coporationInfomation',
];

export const bankingMapping = {
  organCode: 'organCode',

  valuationRatio: '',
  PE: 'ryd21',
  PB: 'ryd25',
  EPS: 'ryd14',
  BVPS: 'ryd7',

  effectiveRatio: '',
  netInterestIncome: 'rev',
  netInterestIncomeGrowth: 'ryq67',
  netProfit: 'isa22',
  profitGrowth: 'ryq39',
  NIM: 'ryq44',
  ROA: 'ryq14',
  ROE: 'ryq12',
  depositGrowth: 'rtq51',
  loansGrowth: 'rtq50',
  costToIncome: 'ryq48',
  nonInterestIncomeInterestIncome: 'ryq47',
  YOEA: 'ryq45',
  COF: 'ryq46',

  capitalRatio: '',
  equityPerLiabilities: 'ryq54',
  equityPerLoans: 'ryq55',
  equityPerAssets: 'ryq56',
  LDR: 'ryq57',
  CAR: 'nob151',

  assetQualityRatio: '',
  CASARatio: 'casa',
  NPL: 'ryq58',
  NPLs: 'ryq59',
  LLRL: 'ryq60',
  POL: 'ryq61',

  coporationInfomation: '',
  marketCapital: 'ryd11',
  outstandingShare: 'ryd3',
};

export const subIndicators = [
  'revenueGrowth',
  'profitGrowth',
  'netInterestIncomeGrowth',
];

export const groupIndicators = [
  'effectiveRatio',
  'liquidityRatio',
  'efficiencyRatio',
  'capitalStructureRatio',
  'valuationRatio',
  'coporationInfomation',
];

export const groupIndicatorsBanking = [
  'effectiveRatio',
  'capitalRatio',
  'assetQualityRatio',
  'valuationRatio',
  'coporationInfomation',
];

export const groupIndicatorsBankingParent = [
  {
    effectiveRatio: [
      'netInterestIncome',
      'netInterestIncomeGrowth',
      'netProfit',
      'profitGrowth',
      'NIM',
      'ROA',
      'ROE',
      'depositGrowth',
      'loansGrowth',
      'costToIncome',
      'nonInterestIncomeInterestIncome',
      'YOEA',
      'COF',
    ],
  },
  {
    capitalRatio: [
      'equityPerLoans',
      'equityPerAssets',
      'equityPerLiabilities',
      'LDR',
      'CAR',
      'POL',
    ],
  },
  {
    assetQualityRatio: ['CASARatio', 'NPL', 'NPLs', 'LLRL'],
  },
  {
    valuationRatio: ['PE', 'PB', 'EPS', 'BVPS'],
  },
  {
    coporationInfomation: ['marketCapital', 'outstandingShare'],
  },
];

export const defaultIndicatorBanking = [
  'netInterestIncome',
  'netInterestIncomeGrowth',
  'netProfit',
  'profitGrowth',
  'equityPerLiabilities',
  'LDR',
  'NPL',
  'NIM',
  'depositGrowth',
  'loansGrowth',
  'NPLs',
  'BVPS',
  'ROA',
  'ROE',
  'costToIncome',
  'nonInterestIncomeInterestIncome',
  'YOEA',
  'COF',
  'marketCapital',
  'outstandingShare',
  'PE',
  'PB',
  'EPS',
  'equityPerLoans',
  'equityPerAssets',
  'CAR',
  'CASARatio',
  'LLRL',
  'POL',
  'effectiveRatio',
  'capitalRatio',
  'assetQualityRatio',
  'valuationRatio',
  'coporationInfomation',
];

export const ignoreMappings = [
  mapping.organCode,
  mapping.revenueGrowth,
  mapping.profitGrowth,

  bankingMapping.profitGrowth,
  bankingMapping.netInterestIncomeGrowth,
];

export const formatPercentKeys = [
  mapping.revenueGrowth,
  mapping.profitGrowth,
  mapping.EBITMargin,
  mapping.netProfitMargin,
  mapping.grossProfitMargin,
  mapping.ROE,
  mapping.ROA,
  mapping.ROIC,

  bankingMapping.netInterestIncomeGrowth,
  bankingMapping.profitGrowth,
  bankingMapping.NIM,
  bankingMapping.ROA,
  bankingMapping.ROE,
  bankingMapping.depositGrowth,
  bankingMapping.loansGrowth,
  bankingMapping.COF,
  bankingMapping.LDR,
  bankingMapping.CAR,
  bankingMapping.NPL,
  bankingMapping.NPLs,
  bankingMapping.LLRL,
  bankingMapping.POL,
  bankingMapping.CASARatio,
  bankingMapping.costToIncome,
  bankingMapping.nonInterestIncomeInterestIncome,
  bankingMapping.YOEA,
];

export const formatBillionKeys = [
  mapping.revenue,
  mapping.netProfit,
  mapping.marketCapital,

  bankingMapping.marketCapital,
];

export const formatMillionKeys = [
  mapping.outstandingShare,

  bankingMapping.outstandingShare,
];

export const formatTrillionKeys = [
  bankingMapping.netInterestIncome,
  bankingMapping.netProfit,
];

export const formatIntegerKeys = [mapping.EPS, mapping.BVPS];
